<template>
  <div class="tab_content search_like_box">
    <div class="search_like_input" :class="{'likeActive': likeActive}">
      <v-textarea
          outlined
          name="input-7-4"
          label=""
          placeholder="可输入任意中文/英文文本的关键字段，建议输入一段技术描述文本（如权利要求），以获取相关的结果。"
          v-model="textData"
          hide-details
          @focus="likeActive = true"
          @blur="likeActive = false"
      ></v-textarea>
    </div>
    <div class="btn_item">
      <div class="clear_btn" @click="textData=''">
        <i class="icon"></i>
        <span>清空</span>
      </div>
      <v-btn color="primary" @click="goLikeSearch">
        <v-icon>mdi-magnify</v-icon>
        <span>检索</span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import Qs from "qs";
export default {

  name: "index",
  data() {
    return {
      textData: "",

    }
  },
  methods: {
    goLikeSearch() {
      let key = this.textData;
      if (!key) {
        this.$message({
          type: "info",
          message: "请输入关键词",
        });
        return false;
      }
      let _this = this;
      let data = {
        keywords: key,
      };
      this.setSearchKey(this.textData)
      data = Qs.stringify(data);
      this.setSearchType(3)
      this.getSearchLike({
        data: data,
        handle(res) {
          let value = res.searchQuery;
          _this.$router.push({
            path: "/search/result",
            query: {
              str: value,
            },
          });
        },
      });
    },
  },
}
</script>

<style scoped>

</style>